export default {
  hostname: 'https://api.fairpy.com',
  // hostname: 'http://localhost:8000',
};
